function i(r, t) {
  for (var e = -1, a = Array(r); ++e < r; )
    a[e] = t(e);
  return a;
}
export {
  i as default
};
